import i18n from '../../i18n'

export const NumericDB = () => {
  const data = []
  for (let i = 1; i < 31; i++) {
    data.push({ label: i18n.t('general.training', { number: i.toString() }), value: i })
  }
  return data
}
